<template>
<b-modal v-model="showModal" @close="closedModal">
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">Changing password for {{ username }}</p>
        </header>
        <section class="modal-card-body">
            <b-field label="Password">
                <b-input type="password" v-model="password" password-reveal placeholder="Your password" required>
                </b-input>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <b-button label="Close" @click="closedModal" />
            <b-button label="Change password" type="is-primary" @click="changePassword" />
        </footer>
    </div>
</b-modal>
</template>

<script>
import userService from '../../services/user.service';

export default {
    name: "change-pass",
    props: ['userIdPass', 'username'],
    data() {
        return {
            password: '',
            showModal: false
        }
    },
    mounted() {
        this.showModal = this.userIdPass > 0
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    methods: {
        changePassword() {
            userService.changePass({
                id: this.userIdPass,
                password: this.password
            }).then(() => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: `Password changed succesfully`,
                    position: 'is-bottom',
                    type: 'is-success'
                })

                this.closedModal()
            })
        },
        closedModal() {
            this.showModal = false

            this.$emit('closeChangePass')
        }
    }
}
</script>

<style>
    </style>
